import { render, staticRenderFns } from "./change_title.vue?vue&type=template&id=1a935d28&"
import script from "./change_title.vue?vue&type=script&lang=js&"
export * from "./change_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports